import { useState, useContext } from "react";

import IdentificationModal from "../../../components/identification-modal";
import SurveySplashCarousel from "../../../components/survey-splash-carousel";
import ConsentModal from "../../../components/consent-modal";

import { SurveySplashDataContext } from "../../../providers/survey-splash-data";

import useCompatNavigate from "../../../hooks/use-compat-navigate";

const SurveySplashScreen = () => {
  const compatNavigate = useCompatNavigate();
  const { surveyMetadata } = useContext(SurveySplashDataContext);
  const { surveyRoute, needsValidation, hasConsent, consentBody } = surveyMetadata;
  const [pressedStartSurvey, setPressedStartSurvey] = useState(false);

  const navigateToSurveyForm = () => {
    compatNavigate(`/encuestas/${surveyRoute}/formulario`);
  };

  const onClickStart = (event) => {
    event.preventDefault();
    if (hasConsent) {
      setPressedStartSurvey(true);
    } else {
      navigateToSurveyForm();
    }
  };

  const onCloseConsentModal = () => setPressedStartSurvey(false);

  const onConsentAccepted = (event) => {
    event.preventDefault();
    navigateToSurveyForm();
  };

  const onConsentDeclined = (event) => {
    event.preventDefault();
    compatNavigate("/encuestas/no-aceptada", { state: { originSurveyRoute: surveyRoute } });
  };

  return (
    <>
      {needsValidation && <IdentificationModal />}
      {hasConsent && (
        <ConsentModal
          consentBody={consentBody}
          isVisible={pressedStartSurvey}
          onCloseModal={onCloseConsentModal}
          onConsentAccepted={onConsentAccepted}
          onConsentDeclined={onConsentDeclined}
        />
      )}
      <SurveySplashCarousel onClickStart={onClickStart} />
    </>
  );
};

export default SurveySplashScreen;
